import { zetApi } from '@zet/network'

export type VerifyCustomerDetailsParams = {
  panNo: string
  customerId: number
  modeOfIncome: number
  dob: string
  pinCode: string
  email: string
  gender: number
}

const verifyCustomerDetails = async ({
  panNo,
  customerId,
  modeOfIncome,
  dob,
  pinCode,
  email,
  gender,
}: VerifyCustomerDetailsParams) => {
  try {
    const response = await zetApi.post('customer/details/basic', {
      panNo,
      customerId,
      modeOfIncome,
      dob,
      pinCode,
      email,
      gender,
    })

    return response.data
  } catch (error) {
    throw 'Something went wrong'
  }
}
export { verifyCustomerDetails }
